import React, { Component } from "react";
import PropTypes from "prop-types";
import { dragNDropConstants } from "../../Globals/constants";
import { DragSource } from "react-dnd";
import Radium from "radium";
import { generateRegisterActivityUrl } from "../../Util/urlhelper";
import { semanticColors } from "../../Globals/styles";
import { greyScaleColors } from "../../Globals/styles";
import ActivityEmployeeDrop from "./activityEmployeeDrop";

const days = [
  "Søndag",
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag"
];

class ActivityComponent extends Component {
  isEmployeeAlreadyDropped = employeeId => {
    return this.props.droppedEmployees[employeeId];
  };
  userIsFormand = () => {
    return this.props.userRole === "Formand";
  };
  isActive = () => {
    const {
      showSidebar,
      draggingEmployee,
      droppedEmployees,
      pool,
      today
    } = this.props;
    if (Object.keys(droppedEmployees).length && showSidebar) {
      //if there is a dragging Employee and this component does not have it as props return false
      if (draggingEmployee != null && !droppedEmployees[draggingEmployee])
        return false;

      //if any of the keys are true, return true.
      let result = false;
      Object.keys(droppedEmployees).forEach(key => {
        if (droppedEmployees[key]) result = true;
      });
      return result;
    } else if (!showSidebar && pool > today) {
      return true;
    }
    return false;
  };
  onClick = () => {
    //if sidebar is not open, redirect to activty
    if (!this.props.showSidebar)
      this.props.redirectTo(
        generateRegisterActivityUrl(
          this.props.params.projectNumber,
          this.props.id
        )
      );
  };
  render() {
    const {
      name,
      registered,
      today,
      connectDragSource,
      isDragging,
      id,
      estimated,
      unread,
      showSidebar,
      registerHours,
      setEmployeeHours,
      activityIsDragging,
      registrationDate
    } = this.props;

    let dayText = "I dag";
    if (new Date().toDateString() != registrationDate.toDateString()) {
      dayText = days[registrationDate.getDay()];
    }
    return (
      <div>
        <div
          className="waves-btn"
          style={[
            styles.aktivityBox,
            this.isActive() && styles.isActiveCard,
            isDragging && styles.dragging,
            activityIsDragging && styles.activityIsDragging
          ]}
        >
          <ActivityEmployeeDrop
            shouldBeDropable={showSidebar}
            activityId={id}
            registerHours={registerHours}
            isEmployeeAlreadyDropped={this.isEmployeeAlreadyDropped}
            setEmployeeHours={setEmployeeHours}
          />
          <div style={styles.header}>
            {connectDragSource(
              <div style={[styles.dragable, showSidebar && styles.hide]}>
                <img src="/images/Drag_and_Drop.png" alt="dragNDrop" />
              </div>
            )}
            <h3 style={styles.h3} onClick={this.onClick}>
              {name}
            </h3>
            {unread ? (
              <div style={styles.infoBtn} onClick={this.onClick}>
                <i className="fa fa-align-left" style={styles.infoIcon}></i>
              </div>
            ) : null}
          </div>

          <div
            className="col-xs-12"
            onClick={this.onClick}
            style={[styles.cardInfo]}
          >
            <div className="col-xs-6" style={styles.hours}>
              <h4 style={styles.h4}>
                {!this.userIsFormand() ? "Tilbud" : "Registreret"}
              </h4>
              <div style={styles.registered}>
                {!this.userIsFormand()
                  ? Math.round(estimated * 10) / 10
                  : registered}
              </div>
            </div>
            <div style={styles.divider}></div>
            <div className="col-xs-6" style={styles.hours}>
              <h4 style={styles.h4}>
                {!this.userIsFormand() ? "Registreret" : dayText}
              </h4>
              <div style={styles.registered}>
                {!this.userIsFormand() ? registered : today}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const activitySource = {
  beginDrag(props) {
    props.setActivityIsDragging(true);
    return {
      id: props.id,
      currentColumnNumber: props.currentColumnNumber,
      currentIndex: props.currentIndex,
      activityName: props.name,
      unread: props.unread,
      isActive: props.pool > props.today
    };
  },
  endDrag(props) {
    props.setActivityIsDragging(false);
  }
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

var styles = {
  dragable: {
    position: "absolute",
    left: "0",
    height: "40px",
    width: "40px",
    textAlign: "center",
    lineHeight: "40px"
  },
  aktivityBox: {
    height: "125px",
    padding: "0",
    position: "relative",
    transition: "height 0.3s",
    overflow: "hidden",
    backgroundColor: greyScaleColors.greyLighter,
    borderRadius: "2px",
    cursor: "pointer",
    display: "block",
    zIndex: "0",
    lineHeight: "inherit"
  },
  isActiveCard: {
    backgroundColor: semanticColors.infoLight
  },
  activityIsDragging: {},
  dragging: {
    opacity: "0"
  },
  registered: {
    fontSize: "30px",
    fontWeight: "bold"
  },
  header: {
    position: "relative",
    width: "100%",
    padding: "0 34px"
  },
  h3: {
    height: "40px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    lineHeight: "40px",
    borderBottom: "1px solid " + semanticColors.mainBackground
  },
  h4: {
    padding: "12px 0 5px 0"
  },
  hours: {
    padding: "0px",
    textAlign: "center"
  },
  cardInfo: {
    position: "relative",
    borderRadius: "0px"
  },
  divider: {
    position: "absolute",
    height: "60px",
    left: "50%",
    top: "10px",
    borderLeft: "1px solid",
    borderColor: semanticColors.mainBackground
  },
  infoBtn: {
    position: "absolute",
    right: "0",
    top: "0",
    width: "0",
    height: "0",
    zIndex: "2",
    borderStyle: "solid",
    borderWidth: "0 40px 40px 0",
    borderColor:
      "transparent " + semanticColors.info + " transparent transparent"
  },
  hide: {
    display: "none"
  },
  infoIcon: {
    marginLeft: "22px",
    marginTop: "4px",
    color: semanticColors.text
  },
  draggingCard: {
    display: "initial"
  }
};
ActivityComponent.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
  registered: PropTypes.number.isRequired,
  estimated: PropTypes.number.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  currentColumnNumber: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  unread: PropTypes.bool.isRequired,
  showSidebar: PropTypes.bool.isRequired,
  registerHours: PropTypes.func.isRequired,
  draggingEmployee: PropTypes.string,
  droppedEmployees: PropTypes.object.isRequired,
  setEmployeeHours: PropTypes.func.isRequired,
  pool: PropTypes.number.isRequired,
  today: PropTypes.number.isRequired,
  redirectTo: PropTypes.func.isRequired,
  setActivityIsDragging: PropTypes.func.isRequired,
  activityIsDragging: PropTypes.bool.isRequired
};
export default DragSource(dragNDropConstants.ACTIVITY, activitySource, collect)(
  Radium(ActivityComponent)
);



// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/activityComponent.jsx